module.exports = __webpack_public_path__ + "img/Poedr.c6d24c82.jpg";